import $api from "../http";
import { IContactInformation } from "../models/ContactInformation";

class ContactInformationServiceClass {
  async getByUserId(userId: string | null) {
    if (!userId) throw new Error("User ID is required");
    return await $api.get<IContactInformation>(`api/contact-information/${userId}`);
  }

  async updateById(model: IContactInformation) {
    const { id, ...rest } = model;
    return await $api.put<boolean>(`api/contact-information/${id}`, rest);
  }
}

export const ContactInformationService = new ContactInformationServiceClass();
